@if (component) {
  <oe-modal-line [name]="component.alias ?? component.id">
    <oe-modal-line-item [channelAddress]="component.id + '/Voltage'" [roleIsAtLeast]="Role.INSTALLER"
    [converter]="Converter.VOLTAGE_IN_MILLIVOLT_TO_VOLT"></oe-modal-line-item>
    <oe-modal-line-item [channelAddress]="component.id + '/Current'" [roleIsAtLeast]="Role.INSTALLER"
    [converter]="Converter.CURRENT_IN_MILLIAMPERE_TO_AMPERE"></oe-modal-line-item>
    <oe-modal-line-item [channelAddress]="component.id + '/ActualPower'" [converter]="Utils.CONVERT_TO_WATT">
    </oe-modal-line-item>
  </oe-modal-line>
}
